// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"14bc2cf7","732":"36c6926c","977":"07b4f2a7"}[chunkId] + ".chunk.js";
};